import React from "react";
import { ArrowRightIcon } from "@heroicons/react/20/solid";
import { Link } from "~/shared";

interface ThemenBoxProps {
  title: string;
  description: string;
  to: string;
  variant?: "default" | "flyout";
}

const ThemenBox: React.FC<ThemenBoxProps> = ({
  title,
  description,
  to,
  variant = "default",
}) => {
  const renderTitle = () => {
    const dotIndex = title.indexOf(".");
    if (dotIndex !== -1 && dotIndex < title.length - 1) {
      const beforeDot = title.slice(0, dotIndex + 1);
      const afterDot = title.slice(dotIndex + 1);

      return (
        <>
          {beforeDot}
          <span className="text-[#FF7300]">{afterDot}</span>
        </>
      );
    }
    return title;
  };

  return (
    <Link
      to={to}
      style={
        variant === "flyout"
          ? {
              backgroundImage: `linear-gradient(to right, #153d71, #005283, #006792, #007c9e, #1f91a7)`,
            }
          : undefined
      }
      className="group flex h-full cursor-pointer flex-col justify-start rounded-2xl border border-white/20 bg-black/30 p-6  text-white shadow-card backdrop-blur-sm transition-all duration-200 hover:border-white/40 hover:bg-black/80 hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70 active:bg-black/90"
    >
      <div className="flex items-start justify-between gap-3">
        <h3 className="text-sm font-semibold md:text-base">{renderTitle()}</h3>
        <ArrowRightIcon className="mt-0.5 h-4 w-4 shrink-0 text-white/90 transition-transform group-hover:translate-x-0.5" />
      </div>
      <p className="mt-1 text-xs text-white/80 md:text-sm">{description}</p>
    </Link>
  );
};

export default ThemenBox;
